import { render, staticRenderFns } from "./MyImgText3.vue?vue&type=template&id=7911495e&scoped=true"
import script from "./MyImgText3.vue?vue&type=script&lang=js"
export * from "./MyImgText3.vue?vue&type=script&lang=js"
import style0 from "./MyImgText3.vue?vue&type=style&index=0&id=7911495e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7911495e",
  null
  
)

export default component.exports